module.exports = __webpack_public_path__ + "img/icon-woodpacking.055b7ae5.svg";